import * as React from "react";
// @ts-ignore
import classnames from "classnames";
import { IConfig, Props, State } from "./types";
import "./styles.scss";

export class Tabs extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      currentTab: props.config[0]?.type || '',
    }

    this.handleClick = this.handleClick.bind(this)
    this.handleRenderTabs = this.handleRenderTabs.bind(this)
  }

  handleClick(pEvt: any) {
    const list = document.querySelectorAll('li[data-type]') as any
    const attr = pEvt?.target?.getAttribute('data-type')

    for (let i = 0; i < list.length; i += 1) {
      list[i].classList.remove('activeTabs')

      if (list[i].dataset!.type === attr) {

        list[i].classList.add('activeTabs')
      }
    }

    this.setState({
      currentTab: attr,
    })
  }

  handleRenderTabs() {
    if (this.props.config.length !== 0) {

      return this.props.config.map((el: IConfig, index: number) => (
        <li
          className={index === 0 && 'activeTabs' || ''}
          onClick={this.handleClick}
          data-type={el?.type}
          key={index}
        >
          {el?.type}
        </li>
      ))
    }

    return
  }

  render() {
    const { SMALL, config} = this.props;

    return (
      <div className={classnames('tabs', SMALL && 'tabs--SMALL')}>
        <ul className="tabs__list">
          { this.handleRenderTabs() }
        </ul>
        <div className='tabs__children'>
          {
            config.find((el: IConfig) => el.type === this.state.currentTab)?.component
          }
        </div>

      </div>
    );
  }
}
